// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.top-side {
  display: flex;
  justify-content: center;
  align-items: start;
  width: 100%;
}

.button-side {
  display: flex;
  justify-content: space-between;
  align-items: center;
  /* border: 1px solid green; */
  width: 100%;
}

.button-side .card-buttons {
  background-color: #fff;
}

.button-side .card-buttons:hover {
  background-color: #fff;
  box-shadow: none;
}

.catalogue-card-logo-new {
  width: 15px !important;
  height: 15px !important;
}

.catalog-new-card .left-side {
  width: 60%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 13px;
  /* gap: 20px; */
  line-height: 22px;
  cursor: pointer;
}

.catalog-new-card .left-side .content {
  width: -webkit-fill-available;
  width: fill;
  display: flex;
  align-items: center;
  gap: 10px;
}

.catalog-new-card .left-side .content .heading  {
  font-family: Karla;
  font-weight: 500;
  font-style: Medium;
  font-size: 18px;
  line-height: 100%;
  letter-spacing: 0%;
  text-align: center;
  vertical-align: middle;
  white-space: nowrap;
}
.description-text {
font-family: Karla;
font-weight: 400;
font-style: Regular;
font-size: 14px;
line-height: 100%;
letter-spacing: 0%;
text-align: center;
vertical-align: middle;

}

.catalog-new-card .left-side .catalogue-card-logo-new {
font-family: Karla;
font-weight: 400;
font-style: Regular;
font-size: 14px;
line-height: 100%;
letter-spacing: 0%;
text-align: center;
vertical-align: middle;
}


.catalog-new-card .right-side {
  width: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.catalog-new-card .right-side .image-div {
  margin: 0;
  padding: 0;
  position: relative;
  /* width: 100%; */
  height: 100%;

  /* border: 1px solid rgb(0, 255, 8); */
}

.catalog-new-card .right-side .clickable-item {
  height: 92px;
  width: 92px !important;
}

.catalog-new-card .right-side .image-div img {
  /* width: 100%; */
  height: 100%;
  border-radius: 5px;
  /* border: 1px solid rgb(147, 6, 222); */
}

.catalog-new-card .right-side button {
  height: 40px;
  margin-top: 5px;
  background-color: #ffffff;
  color: #e77b7b;
  font-size: 18px;
  font-weight: 500;
  font-style: Medium;
  font-size: 18px;
  line-height: 100%;
  letter-spacing: 0%;
  text-align: center;
  vertical-align: middle;
  }
  .description-text {
  font-family: Karla;
  font-weight: 400;
  font-style: Regular;
  font-size: 14px;
  line-height: 100%;
  letter-spacing: 0%;
  text-align: center;
  vertical-align: middle;
   
  }
   
  .catalog-new-card .left-side .catalogue-card-logo-new {
  font-family: Karla;
  font-weight: 400;
  font-style: Regular;
  font-size: 14px;
  line-height: 100%;
  letter-spacing: 0%;
  text-align: center;
  vertical-align: middle;
  }
  
  
  .catalog-new-card .right-side {
    width: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
   
  .catalog-new-card .right-side .image-div {
    margin: 0;
    padding: 0;
    position: relative;
    /* width: 100%; */
    height: 100%;
   
    /* border: 1px solid rgb(0, 255, 8); */
  }
   
  .catalog-new-card .right-side .clickable-item {
    height: 92px;
    width: 92px !important;
  }
   
  .catalog-new-card .right-side .image-div img {
    /* width: 100%; */
    height: 100%;
    border-radius: 5px;
    /* border: 1px solid rgb(147, 6, 222); */
  }
   
  .catalog-new-card .right-side button {
    height: 40px;
    margin-top: 5px;
    background-color: #ffffff;
    color: #e77b7b;
    font-size: 18px;
    font-weight: 500;
    font-family: Poppins;
    transition: height 0.5s ease;
    text-transform: none;
  }
   
  .button-side button {
    height: 40px;
    margin-top: 5px;
    background-color: #ffffff;
    color: #000;
    font-size: 18px;
    font-weight: 500;
    font-family: Poppins;
    transition: height 0.5s ease;
    text-transform: none;
  }
   
  .catalog-new-card .right-side .btn-delete {
    color: #e77b7b;
    border: 0.5px solid #e77b7b;
  }
   
  .catalog-new-card .right-side .btn-unarchive {
    width: 97%;
    /* width: 100%; */
    color: #50c878;
    border: 0.5px solid #50c878;
  }
   
  .catalog-new-card .right-side .btnAdd {
    height: 40px;
    margin-top: 5px;
    background-color: #ffffff;
    color: #50c878;
    font-size: 18px;
    font-weight: 500;
    font-family: Poppins;
    transition: height 0.5s ease;
    text-transform: none;
  }
   
  .catalog-new-card .right-side .btnAdded {
    height: 40px;
    margin-top: 5px;
    background-color: #50c878;
    color: #ffffff;
    font-size: 18px;
    font-weight: 500;
    font-family: Poppins;
    transition: height 0.5s ease;
    text-transform: none;
  }
   
  .catalog-new-card .overlayText {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    color: #ffffff;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 1.25rem;
  }
   
  .catalog-new-card .middle-side {
    width: 20%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 23px;
    line-height: 22px;
    cursor: pointer;
  }
   
  .content-name {
    font-weight: 500;
    font-size: 18px;
    font-family: karla;
    display: flex;
    gap: 5px;
    justify-content: center;
    align-items: center;
    height: 18px;
  }
   
  .content-new {
    /* border: 1px solid green; */
    font: karla;
    font-size: 14px !important;
    font-weight: 400 !important;
    display: flex;
    gap: 10px;
    justify-content: center;
    align-items: center;
    height: 18px;
    width:"153px"
   
  }`, "",{"version":3,"sources":["webpack://./src/features/catalogue/components/catalogCardNew.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,6BAA6B;EAC7B,WAAW;AACb;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,6BAAW;EAAX,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;AACrB;AACA;AACA,kBAAkB;AAClB,gBAAgB;AAChB,mBAAmB;AACnB,eAAe;AACf,iBAAiB;AACjB,kBAAkB;AAClB,kBAAkB;AAClB,sBAAsB;;AAEtB;;AAEA;AACA,kBAAkB;AAClB,gBAAgB;AAChB,mBAAmB;AACnB,eAAe;AACf,iBAAiB;AACjB,kBAAkB;AAClB,kBAAkB;AAClB,sBAAsB;AACtB;;;AAGA;EACE,UAAU;EACV,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;;EAEZ,sCAAsC;AACxC;;AAEA;EACE,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;EACtB;EACA;EACA,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;;EAEtB;;EAEA;EACA,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;EACtB;;;EAGA;IACE,UAAU;IACV,aAAa;IACb,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,SAAS;IACT,UAAU;IACV,kBAAkB;IAClB,iBAAiB;IACjB,YAAY;;IAEZ,sCAAsC;EACxC;;EAEA;IACE,YAAY;IACZ,sBAAsB;EACxB;;EAEA;IACE,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,wCAAwC;EAC1C;;EAEA;IACE,YAAY;IACZ,eAAe;IACf,yBAAyB;IACzB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,4BAA4B;IAC5B,oBAAoB;EACtB;;EAEA;IACE,YAAY;IACZ,eAAe;IACf,yBAAyB;IACzB,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,4BAA4B;IAC5B,oBAAoB;EACtB;;EAEA;IACE,cAAc;IACd,2BAA2B;EAC7B;;EAEA;IACE,UAAU;IACV,iBAAiB;IACjB,cAAc;IACd,2BAA2B;EAC7B;;EAEA;IACE,YAAY;IACZ,eAAe;IACf,yBAAyB;IACzB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,4BAA4B;IAC5B,oBAAoB;EACtB;;EAEA;IACE,YAAY;IACZ,eAAe;IACf,yBAAyB;IACzB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,4BAA4B;IAC5B,oBAAoB;EACtB;;EAEA;IACE,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,oCAAoC;IACpC,cAAc;IACd,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,UAAU;IACV,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;IACT,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,aAAa;IACb,QAAQ;IACR,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;EACd;;EAEA;IACE,6BAA6B;IAC7B,WAAW;IACX,0BAA0B;IAC1B,2BAA2B;IAC3B,aAAa;IACb,SAAS;IACT,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ;;EAEF","sourcesContent":[".top-side {\n  display: flex;\n  justify-content: center;\n  align-items: start;\n  width: 100%;\n}\n\n.button-side {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  /* border: 1px solid green; */\n  width: 100%;\n}\n\n.button-side .card-buttons {\n  background-color: #fff;\n}\n\n.button-side .card-buttons:hover {\n  background-color: #fff;\n  box-shadow: none;\n}\n\n.catalogue-card-logo-new {\n  width: 15px !important;\n  height: 15px !important;\n}\n\n.catalog-new-card .left-side {\n  width: 60%;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 13px;\n  /* gap: 20px; */\n  line-height: 22px;\n  cursor: pointer;\n}\n\n.catalog-new-card .left-side .content {\n  width: fill;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.catalog-new-card .left-side .content .heading  {\n  font-family: Karla;\n  font-weight: 500;\n  font-style: Medium;\n  font-size: 18px;\n  line-height: 100%;\n  letter-spacing: 0%;\n  text-align: center;\n  vertical-align: middle;\n  white-space: nowrap;\n}\n.description-text {\nfont-family: Karla;\nfont-weight: 400;\nfont-style: Regular;\nfont-size: 14px;\nline-height: 100%;\nletter-spacing: 0%;\ntext-align: center;\nvertical-align: middle;\n\n}\n\n.catalog-new-card .left-side .catalogue-card-logo-new {\nfont-family: Karla;\nfont-weight: 400;\nfont-style: Regular;\nfont-size: 14px;\nline-height: 100%;\nletter-spacing: 0%;\ntext-align: center;\nvertical-align: middle;\n}\n\n\n.catalog-new-card .right-side {\n  width: 50%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.catalog-new-card .right-side .image-div {\n  margin: 0;\n  padding: 0;\n  position: relative;\n  /* width: 100%; */\n  height: 100%;\n\n  /* border: 1px solid rgb(0, 255, 8); */\n}\n\n.catalog-new-card .right-side .clickable-item {\n  height: 92px;\n  width: 92px !important;\n}\n\n.catalog-new-card .right-side .image-div img {\n  /* width: 100%; */\n  height: 100%;\n  border-radius: 5px;\n  /* border: 1px solid rgb(147, 6, 222); */\n}\n\n.catalog-new-card .right-side button {\n  height: 40px;\n  margin-top: 5px;\n  background-color: #ffffff;\n  color: #e77b7b;\n  font-size: 18px;\n  font-weight: 500;\n  font-style: Medium;\n  font-size: 18px;\n  line-height: 100%;\n  letter-spacing: 0%;\n  text-align: center;\n  vertical-align: middle;\n  }\n  .description-text {\n  font-family: Karla;\n  font-weight: 400;\n  font-style: Regular;\n  font-size: 14px;\n  line-height: 100%;\n  letter-spacing: 0%;\n  text-align: center;\n  vertical-align: middle;\n   \n  }\n   \n  .catalog-new-card .left-side .catalogue-card-logo-new {\n  font-family: Karla;\n  font-weight: 400;\n  font-style: Regular;\n  font-size: 14px;\n  line-height: 100%;\n  letter-spacing: 0%;\n  text-align: center;\n  vertical-align: middle;\n  }\n  \n  \n  .catalog-new-card .right-side {\n    width: 50%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n   \n  .catalog-new-card .right-side .image-div {\n    margin: 0;\n    padding: 0;\n    position: relative;\n    /* width: 100%; */\n    height: 100%;\n   \n    /* border: 1px solid rgb(0, 255, 8); */\n  }\n   \n  .catalog-new-card .right-side .clickable-item {\n    height: 92px;\n    width: 92px !important;\n  }\n   \n  .catalog-new-card .right-side .image-div img {\n    /* width: 100%; */\n    height: 100%;\n    border-radius: 5px;\n    /* border: 1px solid rgb(147, 6, 222); */\n  }\n   \n  .catalog-new-card .right-side button {\n    height: 40px;\n    margin-top: 5px;\n    background-color: #ffffff;\n    color: #e77b7b;\n    font-size: 18px;\n    font-weight: 500;\n    font-family: Poppins;\n    transition: height 0.5s ease;\n    text-transform: none;\n  }\n   \n  .button-side button {\n    height: 40px;\n    margin-top: 5px;\n    background-color: #ffffff;\n    color: #000;\n    font-size: 18px;\n    font-weight: 500;\n    font-family: Poppins;\n    transition: height 0.5s ease;\n    text-transform: none;\n  }\n   \n  .catalog-new-card .right-side .btn-delete {\n    color: #e77b7b;\n    border: 0.5px solid #e77b7b;\n  }\n   \n  .catalog-new-card .right-side .btn-unarchive {\n    width: 97%;\n    /* width: 100%; */\n    color: #50c878;\n    border: 0.5px solid #50c878;\n  }\n   \n  .catalog-new-card .right-side .btnAdd {\n    height: 40px;\n    margin-top: 5px;\n    background-color: #ffffff;\n    color: #50c878;\n    font-size: 18px;\n    font-weight: 500;\n    font-family: Poppins;\n    transition: height 0.5s ease;\n    text-transform: none;\n  }\n   \n  .catalog-new-card .right-side .btnAdded {\n    height: 40px;\n    margin-top: 5px;\n    background-color: #50c878;\n    color: #ffffff;\n    font-size: 18px;\n    font-weight: 500;\n    font-family: Poppins;\n    transition: height 0.5s ease;\n    text-transform: none;\n  }\n   \n  .catalog-new-card .overlayText {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-color: rgba(0, 0, 0, 0.5);\n    color: #ffffff;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    font-size: 1.25rem;\n  }\n   \n  .catalog-new-card .middle-side {\n    width: 20%;\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 23px;\n    line-height: 22px;\n    cursor: pointer;\n  }\n   \n  .content-name {\n    font-weight: 500;\n    font-size: 18px;\n    font-family: karla;\n    display: flex;\n    gap: 5px;\n    justify-content: center;\n    align-items: center;\n    height: 18px;\n  }\n   \n  .content-new {\n    /* border: 1px solid green; */\n    font: karla;\n    font-size: 14px !important;\n    font-weight: 400 !important;\n    display: flex;\n    gap: 10px;\n    justify-content: center;\n    align-items: center;\n    height: 18px;\n    width:\"153px\"\n   \n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
